import { Box, Grid, Typography } from '@mui/material'
import BlogMailbox from 'public/images/illustration/blog-mailbox.svg'

import { Article } from '@ecm/data/Article'
import { ArticleCategory } from '@ecm/data/ArticleCategory'
import NewsletterSignupCta from '@ecm/ui/component/block/NewsletterSignupCta'
import ArticleCard from '@ecm/ui/component/blog/ArticleCard'
import { CategoriesLinks } from '@ecm/ui/component/blog/CategoriesLinks'
import HeaderBlock from '@ecm/ui/component/blog/HeaderBlock'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'
import Pagination from '@ecm/ui/element/Pagination'
import DefaultLayout from '@ecm/ui/layout/Default'

const categoryDescription: Record<string, string> = {
  'business-start-up': ' the business start-up',
  green: 'the environmental projects',
  lifestyle: ' the lifestyle',
  'product-services': 'Products & Services',
  'running-a-business': 'running a business',
}

export type BlogListProps = {
  articles: Article[]
  canonicalUrl?: string
  categories: ArticleCategory[]
  category?: ArticleCategory
  currentPage: number
  totalPages: number
  categorySlug: string
  pageSlug: string
  seoTitle?: string
}

export const BlogList = ({
  articles,
  canonicalUrl,
  categories,
  categorySlug,
  currentPage,
  totalPages,
  pageSlug,
  seoTitle,
}: BlogListProps) => (
  <DefaultLayout
    canonicalUrl={canonicalUrl}
    finalCtaHeader="Need help with mail management? Join thousands of customers on Earth Class Mail"
    finalCtaSubHeader="Virtual Mail Plans Starting From $29 Per Month."
    finalCta="Sign up"
    seoPage="blog"
    seoTitle={seoTitle}
    seoDescription={
      categoryDescription[categorySlug] &&
      `Read about ${categoryDescription[categorySlug]}, how we are building our business, and how our customers are growing theirs. Page ${currentPage}`
    }
    gradientBackground
  >
    <Box
      sx={{
        background: `linear-gradient(180deg, ${Color.smoke.normal} 520px, rgba(255, 255, 255, 0) 750px)`,
      }}
    >
      <MainContainer sx={{ paddingY: { md: '4em', xs: '2em' } }}>
        <HeaderBlock illustration={BlogMailbox}>
          <Typography variant="p3" maxWidth="500px">
            {`Browse our library of articles about ${
              categoryDescription[categorySlug] ?? 'how to use Earth Class Mail'
            },`}
            <b> helpful tips for remote business owners,</b> and the latest news about mail service
            and our company.
          </Typography>
        </HeaderBlock>

        <CategoriesLinks currentCategorySlug={categorySlug} categories={categories} />

        <Typography variant="h3" component="h2" mb="1em">
          Recent articles
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gap: { md: '4em', xs: '2em' },
            gridTemplateColumns: {
              lg: 'repeat(3, 1fr)',
              sm: 'repeat(2, 1fr)',
              xs: 'repeat(1, 1fr)',
            },
            gridTemplateRows: 'auto',
            justifyContent: 'space-between',
          }}
        >
          {articles.map((article, i) => {
            return <ArticleCard key={article.id} article={article} priority={i < 3} />
          })}
        </Box>
        <Grid container justifyContent="center" paddingY="3.5em" width="100%">
          <Pagination currentPage={currentPage} pageSlug={pageSlug} totalPages={totalPages} />
        </Grid>
        <NewsletterSignupCta trackGaEvents />
      </MainContainer>
    </Box>
  </DefaultLayout>
)

export default BlogList
